import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiBell, FiSearch, FiGlobe, FiCommand } from 'react-icons/fi';

const Header = () => {
  return (
    <header className="h-16 border-b border-cyan-900/30 bg-slate-950/50 backdrop-blur-md flex items-center justify-between px-6 z-10">
      <div className="flex items-center w-96 bg-slate-900/40 border border-slate-800/50 rounded-lg px-3 py-1.5 focus-within:border-cyan-700/50 focus-within:bg-slate-900/80 transition-all group">
        <SafeIcon icon={FiSearch} className="text-slate-600 mr-2 group-focus-within:text-cyan-500" />
        <input 
          type="text" 
          placeholder="Search telemetry, nodes, or playbooks..." 
          className="bg-transparent border-none outline-none text-sm text-slate-200 w-full placeholder-slate-600 font-light" 
        />
        <div className="flex items-center space-x-1 px-1.5 py-0.5 rounded border border-slate-800 bg-slate-950">
          <SafeIcon icon={FiCommand} className="text-[10px] text-slate-600" />
          <span className="text-[10px] text-slate-600 font-mono">K</span>
        </div>
      </div>

      <div className="flex items-center space-x-6">
        <div className="hidden md:flex items-center space-x-4 border-r border-slate-800 pr-6">
          <div className="flex flex-col items-end">
            <span className="text-[10px] font-bold text-cyan-500 uppercase tracking-tighter">Cluster Health</span>
            <span className="text-xs text-slate-400 font-mono">NOMINAL (99.8%)</span>
          </div>
          <SafeIcon icon={FiGlobe} className="text-emerald-500" />
        </div>

        <div className="flex items-center space-x-4">
          <button className="relative text-slate-400 hover:text-cyan-300 transition-colors p-2 hover:bg-cyan-500/5 rounded-full">
            <SafeIcon icon={FiBell} className="text-xl" />
            <span className="absolute top-2 right-2 w-2 h-2 bg-amber-500 rounded-full shadow-[0_0_8px_#f59e0b]"></span>
          </button>
          
          <div className="flex items-center space-x-3 pl-2">
            <div className="flex flex-col items-end hidden sm:flex">
              <span className="text-xs font-bold text-white tracking-wide">Commander Alpha</span>
              <span className="text-[10px] text-slate-500 font-mono uppercase">Level 4 Access</span>
            </div>
            <div className="h-9 w-9 rounded bg-gradient-to-br from-cyan-600 to-slate-800 border border-cyan-400/30 flex items-center justify-center shadow-lg">
              <span className="text-xs font-bold text-white">OP</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;